import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import Axios from "axios";
import MarkdownIt from "markdown-it";
import MarkdownItLinkAttributes from "markdown-it-link-attributes";
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { Fancybox, Carousel } from "@fancyapps/ui";

(<any>window).Vue = Vue;
(<any>window).Vuex = Vuex;
(<any>window).VueRouter = VueRouter;
(<any>window).Axios = Axios;
(<any>window).MarkdownIt = MarkdownIt;
(<any>window).MarkdownItLinkAttributes = MarkdownItLinkAttributes;
(<any>window).Loader = Loader;
(<any>window).MarkerClusterer = MarkerClusterer;
(<any>window).Fancybox = Fancybox;
(<any>window).Carousel = Carousel;